import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { Status } from '@yobora/models/rights'

export interface Login {
  type: 'Login'
  userName: string
  password: string
  [startFetch]: string
}

export interface Logout {
  type: 'Logout'
}

export interface LoginSuccess {
  type: 'LoginSuccess'
  companyId: string
  userName: string
  rights: Status[]
  token: string
  initials: string
  [stopFetch]: string
}

export interface LoginFailure {
  type: 'LoginFailure'
  [stopFetch]: string
}

export interface LoginForgotPassword {
  type: 'LoginForgotPassword'
  email: string
}

export interface LoginForgotPasswordNoEmail {
  type: 'LoginForgotPasswordNoEmail'
}

export const loginActions = unionize({
  ...ofType<Login>('Login'),
  ...ofType<Logout>('Logout'),
  ...ofType<LoginSuccess>('LoginSuccess'),
  ...ofType<LoginFailure>('LoginFailure'),
  ...ofType<LoginForgotPassword>('LoginForgotPassword'),
  ...ofType<LoginForgotPasswordNoEmail>('LoginForgotPasswordNoEmail')
})

export type LoginActions = UnionOf<typeof loginActions>



// WEBPACK FOOTER //
// ./src/users-components/login/login.actions.ts